<script>
	import jQuery from 'jquery';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let obj;

	console.log(obj);

	let view = "more";

	let initMovie = "2001: A Space Odyssey";
	
	function clickMovie(event) {
			dispatch("message", {
					text: this.innerText 
				})
		}

	let movies = ["2001: A Space Odyssey", "Arrival", "Blade Runner 2049", "The Neon Demon", "Interstellar", "Drive", "Only God Forgives", "Blade Runner",  "Tree of Life", "Moonrise Kingdom", "The Grand Budapest Hotel", "Her", "In the Mood for Love", "Moonlight", "The Matrix", "Amélie", "Joker", "Akira", "American Beauty", "The Truman Show", "Princess Mononoke"]

	function parsing(x) {
			x = x.replace(/\s+/g,"").replace("'","").replace(":","").replace("é","e").toLowerCase();
			return x
		}

</script>

<div class="wrapper py-5">

	<div class="pb-3 accordion" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
       	Choose a movie 
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        
				<div class="text-start">

	<input type="radio" checked id="{parsing(initMovie)}" name="movies">
	<label for="{parsing(initMovie)}" on:click={clickMovie}>{initMovie}</label>

	{#each movies.slice(1,movies.length) as movie}
		<span class="">•</span>
  		<input type="radio" id="{parsing(movie)}" name="movies">
			<label for="{parsing(movie)}" on:click={clickMovie}>{movie}</label>
			<span class=""> </span>
	{/each}

				</div>

      </div>
    </div>
  </div>
 	</div>

	

</div>

<style>
.wrapper {
	max-width: 700px;
	margin: 0 auto;
}

label {
	font-weight: 500;
	border-radius: 0px;
	padding: 8px;
	margin: 2px;
	border-radius: 5px;
}

input {
	display: none;
}

input[type="radio"]:checked+label {
	color: #000;
	border: 2px solid #000;
	padding: 6px;
}

.link-view {
	color: #aaa;
}

.accordion-button:not(.collapsed) {
    color: #000;
    background-color: #fff;
    box-shadow: inset 0 -1px 0 #00000020;
}

.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

</style>
